import React from 'react';
import { Link, Outlet, Params, useParams } from 'react-router-dom';

import styled from 'styled-components';
import { Color } from '@joinforma/ui/constants/themes';

import { ReactComponent as Close } from '@joinforma/ui/assets/icons/close.svg';
import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

const Container = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const CloseLink = styled(Link)`
  padding: 24px 24px 0 0;

  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    padding: 52px 52px 0 0;
  }
`;

const CloseIcon = styled(Close)`
  width: 20px;
  height: 20px;
  path {
    stroke: ${Color.BLACK_100};
  }
`;

const FullScreenLayout = ({
  children,
  back_path,
  getBackPathFromParams,
}: {
  children?: React.ReactNode;
  back_path?: string;
  getBackPathFromParams?: ({ params }: { params: Params }) => string;
}) => {
  const params = useParams();
  const calculated_back_path = getBackPathFromParams
    ? getBackPathFromParams({ params })
    : back_path;
  if (!calculated_back_path) {
    throw new Error('No back path specified for onClose method of fullscreen');
  }

  return (
    <Container role={'main'}>
      <Header>
        <CloseLink to={calculated_back_path} aria-label={'Close and go back'}>
          <CloseIcon />
        </CloseLink>
      </Header>
      {children ?? <Outlet />}
    </Container>
  );
};

export default FullScreenLayout;
